import React from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { ReactComponent as CoreLogo } from '../../assets/images/GH-GHX-Logos-Orange.svg';

const MaintenanceContainer = styled.div`
	height: 100%;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
	padding: 0 24px;
	background-color: ${themeGet('colors.backgroundLM')};
`;

const Logo = styled(CoreLogo)`
	width: 280px;
	max-width: 80%;
	height: auto;
	margin-bottom: 48px;
`;

const Title = styled.h1`
	font-family: ${themeGet('fonts.heading')};
	font-size: ${themeGet('fontSizes.xLarge')};
	color: ${themeGet('colors.darkGrey')};
	margin: 0 0 16px;
`;

const Message = styled.p`
	font-family: ${themeGet('fonts.base')};
	font-size: ${themeGet('fontSizes.large')};
	color: ${themeGet('colors.mediumGrey')};
	max-width: 540px;
	line-height: 1.5;
	margin: 0;
`;

/**
 * localStorage key that, when set to 'true', bypasses maintenance mode so the
 * app can still be accessed/tested while REACT_APP_MAINTENENCE_MODE is enabled.
 */
export const REMOVE_MAINTENANCE_KEY = 'removeMaintenence';

/**
 * Whether the app should be blocked behind the maintenance page.
 * Driven by the REACT_APP_MAINTENENCE_MODE env var, but bypassed when the
 * 'removeMaintenence' localStorage flag is set to 'true'.
 */
export const isMaintenanceModeActive = (): boolean =>
{
	const maintenanceEnabled = process.env.REACT_APP_MAINTENENCE_MODE === 'true';
	const bypass = localStorage.getItem(REMOVE_MAINTENANCE_KEY) === 'true';

	return maintenanceEnabled && !bypass;
};

/**
 * Full-screen page shown when maintenance mode is active.
 * Rendered before any routing/login so users cannot access the app while
 * maintenance is in progress.
 */
export const MaintenancePage = () =>
{
	return (
		<MaintenanceContainer>
			<Logo />
			<Title>We&apos;ll be back soon</Title>
			<Message>
				The application is currently undergoing scheduled maintenance.
				We apologize for the inconvenience and will be back online shortly.
			</Message>
		</MaintenanceContainer>
	);
};
